//LL: 12.07.23 Calendar (copy Grid)

import * as React from 'react';
import * as _ from 'underscore'; //LL: 16.07.23: try after OE's great changes in GIT
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';

//LL: new Calendar    build
// pdc-widget-calendar/src/ts/components/AttrQueryField.tsx(10,8): error TS2613:
// Module '"C:/agent/_work/2/s/applications/PDCDashboard/frontend/src/_common/platform/tsx/FormatChooser"'
// has no default export.
// Did you mean to use 'import { FormatChooser }
// from "C:/agent/_work/2/s/applications/PDCDashboard/frontend/src/_common/platform/tsx/FormatChooser"' instead?
//import FormatChooser, { IFormatChooserValue } from '../../../../_common/platform/tsx/FormatChooser';
//LL: and this is bad here:
//import { FormatChooser } from '../../../../_common/platform/tsx/FormatChooser';
//import { IFormatChooserValue } from '../../../../_common/platform/tsx/FormatChooser';

import AttributeDesigner, { IToggleStates } from '../../../../_common/platform/tsx/attributeDesigner/AttributeDesigner';

import SelectField from '../../../../_common/platform/tsx/SelectField';
import AttributeOptionsSelect from '../../../../pdc-widget-calendar/src/ts/components/AttributeOptionsSelect';
import NumberSpinner from '../../../../_common/platform/tsx/NumberSpinner';

import AttributeSortingSelect, {
    AttributeSortingSelectHeader
} from '../../../../_common/platform/tsx/AttributeSortingSelect';

import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import StringField from '../../../../_common/platform/tsx/StringField';
import * as AttrQueryValuesFormat from '../../../../_common/platform/ts/AttrQueryValuesFormat';

import * as ConfigurationConstantsApp from '../../../../_common/application/ts/ConfigurationConstants';
import * as ConfigurationConstants from '../../../../_common/platform/ts/ConfigurationConstants';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';

import { IExpression, ITreeItem } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

import { IntervalsSelect } from '../../../../_common/platform/tsx/IntervalsSelect';
import { IAttrQuery } from '../../../../pdc-widget-calendar/src/ts/components/Interfaces';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { DiscreteIntervalsKind } from '../../../../_common/platform/tsx/DiscreteIntervals';
import { useElementsReorderingHook } from '../../../../_common/platform/ts/DragDropCommon';
import { FormatChooser } from '../../../../_common/platform/tsx/FormatChooser';

function getType(attribute: string, glob: IGlob, dataSourceID: number) {
    return glob.EntityModelsStore.getAttributeType(attribute, dataSourceID);
}

function AttrQueryFieldRow(props: {
    dataSourceID?: number;
    value?: IAttrQuery;
    index?: number;
    maxIndex?: number;
    theme: IValuesCollection;
    endlessScrolling: boolean;
    disableClickToFilter: boolean;
    validEntities: string[];
    tabID: number;

    isEmpty?: boolean;

    entitiesTree: ITreeItem[];
    entityCollapsedDict: IToggleStates;
    glob: IGlob;

    DisplayValuesList?: any; //LL: new Calendar
    hiddenFields?: any; //LL: 10.08.23  Calendar HiddenFields_Summary = ['InitGrouping','Sort', 'Format', 'More', 'Label'];
    //LL: 16.08.23:
    //private static HiddenFields_Summary = {
    //        InitGrouping: true,
    //        Sort: true,
    //        Format: true,
    //        More: true,
    //        Label: true
    //    };

    onAdd?(checkedItems: string[], expression: IExpression): void;
    onChange?(value: IAttrQuery, index: number): void;
    onRemove?(index: number): void;
    onSortSet?(index: number, value): void;
    onInitGroupingSortSet?(index: number, value): void;
    onEntityCollapsedDictChange?(value: IToggleStates): void;
}) {
    //const tableRef = React.useRef<HTMLTableSectionElement>(null);
    //const dataGridRef = React.useRef<DataGrid>();  // ref={dataGridRef}
    const roleFieldRef = React.useRef<HTMLSelectElement>(null); // dataGridRef.current.instance

    const getValueCopy = (): IAttrQuery => {
        return _.clone(props.value || {}) as IAttrQuery;
    };

    const normalize = (value: IAttrQuery) => {
        if (value.sort != null && value.sortOnValues == null) {
            value.sortOnValues = false; // WorkItem [102543]: Do not set "sort on value" by default when sorting for attribute is not 'none'
        }

        if (value.fixed == null || (props.index !== 0 && props.index !== props.maxIndex)) {
            value.fixed = false;
        }

        if (value.hideColumn == null) {
            value.hideColumn = false;
        }

        if (value.sort == null) {
            delete value.sortOnValues;
            delete value.sortOrder;
        }

        if (value.initGrouping == false || value.initGrouping == null) {
            delete value.initGroupingOrder;
        }

        if (value.intervals == null) {
            delete value.intervals;
        }

        if (value.putValueInExchangeObject !== true) {
            delete value.exchangeObjectName;
        }

        if (value.attribute == null && value.expression == null) {
            delete value.role; //LL: new Calendar
            return;
        }

        let attributeType = getType(value.attribute, props.glob, props.dataSourceID);

        if (attributeType == null) {
            return;
        }

        const isCountAggregate = AttrQueryValuesFormat.isCountAggregate(value);

        let attrType = props.glob.EntityModelsStore.getDefaultAttributeType(value.attribute, props.dataSourceID);
        if (attrType == null) {
            attrType = attributeType;
        }

        //switch (attributeType) {
        switch (attrType) {
            case 's':
                if (
                    !isCountAggregate &&
                    !AttrQueryValuesFormat.isMinMaxAggregate(value) &&
                    !AttrQueryValuesFormat.isAvgAggregate(value)
                ) {
                    deleteFormatting(value);
                }
                break;

            case 'e':
                if (!isCountAggregate) {
                    delete value.intervals;

                    if (
                        !AttrQueryValuesFormat.isMinMaxAggregate(value) &&
                        !AttrQueryValuesFormat.isAvgAggregate(value)
                    ) {
                        deleteFormatting(value);
                    }
                }
                break;

            case 'b':
                delete value.precision;

                //LL: 26.10.21: rem
                //if (!isCountAggregate) {
                //    delete value.intervals;
                //}
                break;

            case 'none':
                deleteFormatting(value);
                delete value.intervals;
                break;
        }

        if (!showingGraphIsAllowed(value, attributeType)) {
            delete value.showGraph;
            delete value.graphOption;
        }

        const findAggregate = _.find(ConfigurationConstantsApp.AGGREGATE_GROUP_VALUES[attributeType], (val) => {
            return val === value.aggregateGroup;
        });

        if (findAggregate == null) {
            delete value.aggregateGroup;
        }

        if (value.formatFront == null) {
            value.formatFront = 'default';
            delete value.currency;
        }

        if (value.formatFront != null) {
            if (value.formatFront.indexOf('currency') === -1) {
                delete value.currency;
            }

            attributeType = AttrQueryValuesFormat.getAttributeTypeByAggregate(value, attributeType);

            if (attributeType === 'b' || attributeType === 'i' || attributeType === 'r') {
                let formatList = ConfigurationConstants.FORMATS[attributeType];
                if (formatList == null) {
                    formatList = ConfigurationConstants.TIME_PART_FORMAT_ELEMENTS['not_set'];
                }

                normalizeFormatFrontByFormatList(value, formatList);
            }

            if (DateTimeFunctions.isTypeOfAnyDate(attributeType)) {
                let timePart: string;

                if (value.intervals != null && value.intervals.timePart != null) {
                    timePart = value.intervals.timePart;
                }

                let formatList: ConfigurationConstants.IFormatElement[];

                if (timePart != null) {
                    formatList = ConfigurationConstants.TIME_PART_FORMAT_ELEMENTS[timePart];
                } else {
                    //type is "time":
                    if (attributeType === 'time') {
                        formatList = ConfigurationConstants.TIME_PART_FORMAT_ELEMENTS['type_time'];
                    } else {
                        formatList = ConfigurationConstants.TIME_PART_FORMAT_ELEMENTS['default'];
                    }
                }

                if (formatList == null) {
                    formatList = ConfigurationConstants.TIME_PART_FORMAT_ELEMENTS['not_set'];
                }

                normalizeFormatFrontByFormatList(value, formatList);
            }
        }
    };

    const deleteFormatting = (value: IAttrQuery) => {
        delete value.formatFront;
        delete value.precision;
        delete value.useDigitGrouping;
        delete value.formatZeroAsBlank;
        delete value.currency;
    };

    const normalizeFormatFrontByFormatList = (
        value: IAttrQuery,
        formatList: ConfigurationConstants.IFormatElement[]
    ) => {
        const findFormat = _.find(formatList, (val) => {
            return val.value === value.formatFront;
        });

        if (findFormat == null) {
            delete value.formatFront;
        }
    };

    const showingGraphIsAllowed = (value: IAttrQuery, attributeType: string) => {
        return (
            attributeType === 'i' ||
            attributeType === 'r' ||
            AttrQueryValuesFormat.isCountAggregate(value) ||
            AttrQueryValuesFormat.isMinMaxAggregate(value) ||
            AttrQueryValuesFormat.isAvgAggregate(value)
        );
    };

    const processOnAdd = (checkedItems: string[], expression: IExpression) => {
        if (typeof props.onAdd === 'function') {
            props.onAdd(checkedItems, expression);
        }
    };

    const getAttributeOnChangeHandlter = (isEmpty: boolean) => {
        return (values: string[]) => {
            if (isEmpty) {
                processOnAdd(values, undefined);
            } else {
                const obj = getValueCopy();
                const newAttribute = values[0];
                const oldAttributeType = getType(obj.attribute, props.glob, props.dataSourceID);
                const newAttributeType = getType(newAttribute, props.glob, props.dataSourceID);

                if (newAttributeType !== oldAttributeType) {
                    delete obj.intervals;
                }

                obj.attribute = newAttribute;
                delete obj.expression;
                delete obj.clickToFilterAttribute;

                handleValueChange(obj);
            }
        };
    };

    const getExpressionOnChangeHandlter = (isEmpty: boolean) => {
        if (isEmpty) {
            return (expression: IExpression) => {
                processOnAdd(undefined, expression);
            };
        } else {
            return (expression: IExpression) => {
                const obj = getValueCopy();

                obj.expression = expression;
                delete obj.attribute;

                handleValueChange(obj);
            };
        }
    };

    const handleAggregateChange = (value: string) => {
        const obj = getValueCopy();

        if (value === 'none') {
            delete obj.aggregateGroup;
        } else {
            obj.aggregateGroup = value;
        }

        handleValueChange(obj);
    };

    const handleSortOrderChange = (value) => {
        if (typeof props.onSortSet === 'function') {
            props.onSortSet(props.index, value);
        }
    };

    const processInitGroupingSortOrderChange = (val) => {
        processInitGroupingSortSet(val);
    };

    const handleIntervalsChange = (value, withMappings) => {
        const obj = getValueCopy();

        if (withMappings === true) {
            obj.intervals = value.intervals;

            if (value.mapping != null) {
                obj.mapping = value.mapping;
            } else {
                delete obj.mapping;
            }
        } else {
            obj.intervals = value;
        }

        handleValueChange(obj);
    };

    //const handleFormatFrontChange = (value: IFormatChooserValue) => {
    const handleFormatFrontChange = (value: any) => {
        const obj: any = getValueCopy();

        if (value.formatFront == null) {
            delete obj.formatFront;
            delete obj.customFormat;
            delete obj.currency;
        } else {
            obj.formatFront = value.formatFront;
            obj.customFormat = value.customFormat;
            obj.currency = value.currency;
        }

        obj.precision = value.precision;
        obj.useDigitGrouping = value.useDigitGrouping;
        obj.formatZeroAsBlank = value.formatZeroAsBlank;
        obj.useFiscalPrefix = value.useFiscalPrefix;
        obj.fiscalYearDivider = value.fiscalYearDivider;
        obj.cellStyle = value.cellStyle;
        obj.template = value.template;

        handleValueChange(obj);
    };

    const handleLabelChange = (value) => {
        const obj = getValueCopy();

        obj.label = value;

        handleValueChange(obj);
    };

    //LL: new Calendar
    const handleRoleChange = (e) => {
        // (value)
        const obj = getValueCopy();

        //obj.role = value;

        //let r = roleFieldRef.current;
        let val = roleFieldRef.current.value;

        if (val === 'none') {
            delete obj.role;
        } else {
            obj.role = val;
        }

        handleValueChange(obj);
    };

    const handleGetInitGroupingChange = (value: boolean) => {
        const obj = getValueCopy();

        obj.initGrouping = value;

        handleValueChange(obj);
    };

    const handleValueChange = (value: IAttrQuery) => {
        normalize(value);

        if (typeof props.onChange === 'function') {
            props.onChange(value, props.index);
        }
    };

    const processInitGroupingSortSet = (value) => {
        if (typeof props.onInitGroupingSortSet === 'function') {
            props.onInitGroupingSortSet(props.index, value);
        }
    };

    const handleRemove = () => {
        if (typeof props.onRemove === 'function') {
            props.onRemove(props.index);
        }
    };

    const getIsEmpty = (value: IAttrQuery) => {
        return props.isEmpty === true || (value.attribute == null && value.expression == null);
    };

    const getAttribute = (value: IAttrQuery) => {
        const isEmpty = getIsEmpty(value);

        let attribute;

        if (value.expression != null) {
            attribute = value.expression;
        } else {
            attribute = value.attribute;
        }

        return (
            <AttributeDesigner
                tree={props.entitiesTree}
                dataSourceID={props.dataSourceID}
                modes={['attribute', 'expression']}
                value={attribute}
                collapsedDict={props.entityCollapsedDict}
                showRemoveButton={true}
                multiselect={isEmpty}
                tabID={props.tabID}
                validEntities={props.validEntities}
                glob={props.glob}
                onChange={getAttributeOnChangeHandlter(isEmpty)}
                onExpressionChange={getExpressionOnChangeHandlter(isEmpty)}
                onRemove={handleRemove}
            />
        );
    };

    const getAggregate = (value: IAttrQuery, attributeType: string) => {
        if (getIsEmpty(value)) {
            return;
        }

        const options = _.map(ConfigurationConstantsApp.AGGREGATE_GROUP_VALUES[attributeType], (value, i) => {
            return (
                <option key={value + '-' + i} value={value}>
                    {value}
                </option>
            );
        });

        const displayVal = value.aggregateGroup || 'none';

        return (
            <SelectField value={displayVal} onChange={handleAggregateChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}
            </SelectField>
        );
    };

    const getSortingSelect = (value: IAttrQuery) => {
        if (getIsEmpty(value)) {
            return;
        }

        return (
            <AttributeSortingSelect value={value} onChange={handleValueChange} onSortOrderSet={handleSortOrderChange} />
        );
    };

    const getInitGroupingOrder = (value: IAttrQuery) => {
        if (getIsEmpty(value) || value.initGrouping == null || value.initGrouping == false) {
            return;
        }

        return <NumberSpinner value={value.initGroupingOrder} onChange={processInitGroupingSortOrderChange} />;
    };

    const getIntervals = (value: IAttrQuery, attributeType: string) => {
        if (getIsEmpty(value)) {
            return;
        }

        if (AttrQueryValuesFormat.isCountAggregate(value)) {
            attributeType = 'i';
        }
        //LL: 26.10.21: rem 'b'
        //if (attributeType === 'e' || attributeType === 'b' || attributeType === 'none') {
        //    return;
        //}
        if (attributeType === 'e' || attributeType === 'none') {
            return;
        }

        //let targetTypes = [DiscreteIntervalsKind.icon, DiscreteIntervalsKind.label, DiscreteIntervalsKind.color];
        //LL: 26.04.23 BL
        const targetTypes = [
            DiscreteIntervalsKind.icon,
            DiscreteIntervalsKind.label,
            DiscreteIntervalsKind.color,
            DiscreteIntervalsKind.boolean
        ];

        return (
            <IntervalsSelect
                value={value.intervals}
                type={attributeType}
                withMappings={true}
                mapping={value.mapping}
                targetTypes={targetTypes}
                onChange={handleIntervalsChange}
                themeObj={props.theme}
                glob={props.glob}
            />
        );
    };

    const getFormatFront = (value: IAttrQuery) => {
        if (getIsEmpty(value)) {
            return;
        }

        const attributeType = props.glob.EntityModelsStore.getDefaultAttributeType(value, props.dataSourceID);

        var customizeFormat = true;

        if (value.aggregateGroup != undefined && value.aggregateGroup == 'count') {
            //VR
            customizeFormat = true;
        } else if (
            attributeType !== 'i' &&
            attributeType !== 'r' &&
            attributeType !== 'b' &&
            !DateTimeFunctions.isTypeOfAnyDate(attributeType)
        ) {
            customizeFormat = false;
        }

        var howToUseText: React.JSX.Element = (
            <div>
                <p>{'Use the label name enclosed in {{...}} or <%...%>.'}</p>
                <p>
                    {'For example:'}
                    <br />
                    <br />
                    {'{{url}} #tabs/1/workspaces {{WSID}}'}
                    <br />
                    {'or'}
                    <br />
                    {'<%url%> #tabs/1/workspaces <%WSID%>'}
                </p>
            </div>
        );

        //LL: 17.06.21:
        let value2: any = $.extend(true, {}, value);
        value2.attrType = attributeType;
        value2.type = attributeType;
        // was value={value}

        //LL: new Calendar   problem
        //return null;

        return (
            <FormatChooser
                isScalar={true}
                value={value2}
                theme={props.theme}
                dataSourceID={props.dataSourceID}
                showAlignmentSelector={true}
                customizeFormat={customizeFormat}
                showStyle={true}
                showTemplate={true}
                showRawTemplate={true}
                //howToUseText={ howToUseText }
                glob={props.glob}
                //getDefaultFormat={ getDefaultFormat }

                onChange={handleFormatFrontChange}
            />
        );
    };

    const getOptionsSelect = (value: IAttrQuery, attributeType: string) => {
        if (getIsEmpty(value)) {
            return;
        }

        const showFixedPosition = props.index === 0 || props.index === props.maxIndex;

        return (
            <AttributeOptionsSelect
                value={value}
                dataSourceID={props.dataSourceID}
                attributeType={attributeType}
                showGraph={showingGraphIsAllowed(value, attributeType)}
                entitiesTree={props.entitiesTree}
                entityCollapsedDict={props.entityCollapsedDict}
                disableClickToFilter={props.disableClickToFilter}
                showFixedPosition={showFixedPosition}
                endlessScrollingIsOn={props.endlessScrolling === true}
                tabID={props.tabID}
                glob={props.glob}
                onChange={handleValueChange}
                onEntityCollapsedDictChange={props.onEntityCollapsedDictChange}
            />
        );
    };

    const getLabel = (value: IAttrQuery) => {
        if (getIsEmpty(value)) {
            return;
        }

        const placeholder = props.glob.EntityModelsStore.getReferredAttributeLabel(value.attribute, props.dataSourceID);

        return <StringField value={value.label || ''} placeholder={placeholder} onChange={handleLabelChange} />;
    };

    //LL: new Calendar   see getDisplay for Gantt
    const getRole = (value: IAttrQuery) => {
        if (getIsEmpty(value)) {
            return;
        }

        const DisplayValuesList = props.DisplayValuesList;

        let CurValueNotInList = true;
        if (value.role == null) {
            CurValueNotInList = false;
        }

        let displayValueArr = ['Attribute'];
        let displayTitleArr = ['Attribute'];
        if (DisplayValuesList != null) {
            displayValueArr = [];
            displayTitleArr = [];
            _.each(DisplayValuesList, function (val: any, index: any) {
                //displayValueArr.push(val.val);
                //displayTitleArr.push(val.text);
                //if (value.role === val.val) {
                //    CurValueNotInList = false;
                //}
                displayValueArr.push(index);
                displayTitleArr.push(val);
                if (value.role === index) {
                    CurValueNotInList = false;
                }
            });
        }

        let displayVal = value.role || 'none';

        let optionNotUsed;
        let OrdinaryOptionStyle;
        let SelectStyle;

        //LL: here in Gantt if CurValueNotInList

        let options = _.map(displayValueArr, function (val: string, i) {
            return (
                <option key={val + '-' + i} value={val} style={OrdinaryOptionStyle}>
                    {displayTitleArr[i]}
                </option>
            );
        });

        let title;

        //Error: Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref

        return (
            <select
                ref={roleFieldRef}
                className="form-control"
                style={SelectStyle}
                onChange={handleRoleChange}
                value={displayVal}
                title={title}
            >
                {optionNotUsed}

                <option key="none" value="none" style={OrdinaryOptionStyle}>
                    {'none'}
                </option>

                {options}
            </select>
        );

        //return "role";
    };

    const getInitGrouping = (value: IAttrQuery) => {
        if (getIsEmpty(value)) {
            return;
        }

        return (
            <div className="nowrap">
                <div className="inline-block">
                    <BooleanField
                        title={''}
                        value={value.initGrouping}
                        allowNull={false}
                        onChange={handleGetInitGroupingChange}
                    />
                </div>
            </div>
        );
    };

    const value: IAttrQuery = props.value || {};

    let attributeType: string;

    if (!getIsEmpty(value)) {
        if (value.attribute != null) {
            attributeType = getType(value.attribute, props.glob, props.dataSourceID);
        } else if (value.expression != null) {
            attributeType = value.expression.rettype;
        }

        value.type = attributeType;
    }

    //LL: 10.08.23  Calendar HiddenFields_Summary = ['InitGrouping','Sort', 'Format', 'More', 'Label'];
    let showInitGrouping = true;
    if (props.hiddenFields != null) {
        //showInitGrouping = (_.indexOf(props.hiddenFields, 'InitGrouping') < 0);
        showInitGrouping = props.hiddenFields.InitGrouping != true; //LL: 16.08.23
    }
    //LL: 16.08.23:
    //private static HiddenFields_Summary = {
    //        InitGrouping: true,
    //        Sort: true,
    //        Format: true,
    //        More: true,
    //        Label: true
    //    };

    const initGroupingField =
        //props.endlessScrolling !== true ? (
        props.endlessScrolling !== true && showInitGrouping ? (
            <td className="cell-init-grouping">
                <table className="small_spacing">
                    <tbody>
                        <tr>
                            <td className="no_border" style={{ verticalAlign: 'middle' }}>
                                {getInitGrouping(value)}
                            </td>
                            <td className="no_border" style={{ verticalAlign: 'middle' }}>
                                {getInitGroupingOrder(value)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        ) : null;

    //LL: 16.08.23:
    let showSort = true;
    if (props.hiddenFields != null) {
        showSort = props.hiddenFields.Sort != true;
    }

    //LL: 16.08.23:
    let showFormat = true;
    if (props.hiddenFields != null) {
        showFormat = props.hiddenFields.Format != true;
    }

    //LL: 16.08.23:
    let showMore = true;
    if (props.hiddenFields != null) {
        showMore = props.hiddenFields.More != true;
    }

    //LL: 16.08.23:
    let showLabel = true;
    if (props.hiddenFields != null) {
        showLabel = props.hiddenFields.Label != true;
    }

    return (
        <tr className={props.isEmpty ? 'empty' : 'attribute-row'}>
            <td className="cell-attribute">{getAttribute(value)}</td>

            <td className="cell-group-aggregate">{getAggregate(value, attributeType)}</td>

            {initGroupingField}

            {showSort ? <td className="cell-sorting">{getSortingSelect(value)}</td> : null}

            <td className="cell-intervals">{getIntervals(value, attributeType)}</td>

            {showFormat ? <td className="cell-formatFront">{getFormatFront(value)}</td> : null}

            {showMore ? <td className="cell-formatFront">{getOptionsSelect(value, attributeType)}</td> : null}

            {showLabel ? <td className="cell-label">{getLabel(value)}</td> : null}

            <td className="cell-role">{getRole(value)}</td>
        </tr>
    );
}

interface IAttrQueryFieldProperties {
    value?: IAttrQuery[];
    dataSourceID: number;
    endlessScrolling: boolean;
    disableClickToFilter: boolean;
    validEntities: string[];
    theme: IValuesCollection;
    tabID: number;
    glob: IGlob;

    DisplayValuesList?: any; //LL: new Calendar
    hiddenFields?: any; //LL: 10.08.23  Calendar

    onChange(value: IAttrQuery[]): void;
}

export default function AttrQueryField(props: IAttrQueryFieldProperties) {
    props.glob.EntityModelsStore.useLoadModelsHook();
    const [entityCollapsedDict, setEntityCollapsedDict] = React.useState<IToggleStates>({});
    const tableRef = React.useRef<HTMLTableSectionElement>(null);

    useElementsReorderingHook(
        tableRef,
        {
            axis: 'y',
            sortableItems: 'tr.attribute-row:not(.empty)',
            handle: '.cell-attribute'
        },
        (start, stop) => {
            let value = [...props.value];

            const item = value.splice(start, 1);
            value.splice(stop, 0, item[0]);

            processValueChange(value);
        },
        [props.value]
    );

    const normalizeAttribute = (value: IAttrQuery) => {
        if (value.attribute != null) {
            delete value.expression;
        } else if (value.expression != null) {
            delete value.attribute;
            delete value.type;
        }
    };

    const processValueChange = (value: IAttrQuery[]) => {
        //The first and the last attributes and be fixed only.
        const attribCount = value.length;
        const maxIndex = attribCount - 1;

        for (let index = 0; index < attribCount; index++) {
            const attribute = value[index];

            normalizeAttribute(attribute);

            if (attribute.fixed === true && index !== 0 && index !== maxIndex) {
                attribute.fixed = false;
            }
        }

        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleEntityCollapsedDictChange = (value: IToggleStates) => {
        setEntityCollapsedDict(value);
    };

    const setValueDefaults = (value: IAttrQuery) => {
        value.initGrouping = false;
        value.initGroupingOrder = 1;
        value.fixed = false;
        delete value.units;
        delete value.width;
        delete value.alignment;
    };

    const handleAddRow = (checkedItems: string[], expression: IExpression) => {
        const values = [...props.value];

        if (checkedItems != null) {
            const { dataSourceID } = props;

            _.each(checkedItems, (attribute) => {
                const attributeType = getType(attribute, props.glob, dataSourceID);
                const value: IAttrQuery = {
                    attribute: attribute,
                    type: attributeType
                };

                if (values.length === 0) {
                    setValueDefaults(value);
                }

                values.push(value);
            });
        } else {
            const value: IAttrQuery = {
                expression: expression
            };

            if (values.length === 0) {
                setValueDefaults(value);
            }

            values.push(value);
        }

        processValueChange(values);
    };

    const handleChangeRow = (value: IAttrQuery, index: number) => {
        const values = [...props.value];
        const prev = values.splice(index, 1, value)[0];

        if (prev.sort == null && value.sort != null) {
            processSortSet(index, null, values);
        }

        normalizeSort(values);

        if (prev.initGrouping == null && value.initGrouping != null) {
            processInitGroupingSortSet(index, null, values);
        }

        normalizeInitGroupingSort(values);
        processValueChange(values);
    };

    const handleRemoveRow = (i) => {
        let arr = props.value.slice(0);

        arr.splice(i, 1);

        normalizeSort(arr);
        normalizeInitGroupingSort(arr);

        processValueChange(arr);
    };

    const normalizeSort = (arr: IAttrQuery[]) => {
        const sort = _.filter(arr, (obj) => {
            return obj.sort != null;
        });

        sort.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
        });

        _.each(sort, (obj, i) => {
            obj.sortOrder = i + 1;
        });
    };

    const processSortSet = (index: number, order: number, arr: IAttrQuery[]) => {
        const obj = arr[index];

        const max = _.reduce(
            arr,
            (max, obj: IAttrQuery, i) => {
                if (obj.sortOrder == null) {
                    return max;
                }

                if (max < obj.sortOrder && i !== index) {
                    return obj.sortOrder;
                }

                return max;
            },
            0
        );

        if (order == null || order > max) {
            order = max + 1;
        }

        const find = _.find(arr, (obj) => {
            return obj.sortOrder == order;
        });

        if (find != null) {
            find.sortOrder = obj.sortOrder || max + 1;
        }

        obj.sortOrder = order;

        normalizeSort(arr);
    };

    const handleSortSet = (i, order) => {
        const arr = props.value.slice(0);

        processSortSet(i, order, arr);
        processValueChange(arr);
    };

    const normalizeInitGroupingSort = (value: IAttrQuery[]) => {
        const sort = _.filter(value, (obj) => {
            return obj.initGrouping != null && obj.initGrouping != false;
        });

        sort.sort((a, b) => {
            return a.initGroupingOrder - b.initGroupingOrder;
        });

        _.each(sort, (obj, i) => {
            obj.initGroupingOrder = i + 1;
        });
    };

    const processInitGroupingSortSet = (index: number, order: number, arr: IAttrQuery[]) => {
        const obj = arr[index];
        const max = _.reduce(
            arr,
            (max, obj: IAttrQuery, i) => {
                if (obj.initGroupingOrder == null) {
                    return max;
                }

                if (max < obj.initGroupingOrder && i !== index) {
                    return obj.initGroupingOrder;
                }

                return max;
            },
            0
        );

        if (order == null || order > max) {
            order = max + 1;
        }

        const find = _.find(arr, (obj) => {
            return obj.initGroupingOrder == order;
        });

        if (find != null) {
            find.initGroupingOrder = obj.initGroupingOrder || max + 1;
        }

        obj.initGroupingOrder = order;

        normalizeInitGroupingSort(arr);
    };

    const handleInitGroupingSortSet = (i, order) => {
        const arr = props.value.slice(0);

        processInitGroupingSortSet(i, order, arr);
        processValueChange(arr);
    };

    const { dataSourceID, validEntities, value } = props;

    const entitiesTree = props.glob.EntityModelsStore.getEntitiesTreeByDS(dataSourceID);
    const endlessScrolling = props.endlessScrolling === true;
    const attributesCount = value != null ? value.length : 0;

    //LL: 10.08.23  Calendar  hiddenFields
    const rows = _.map(value, (obj, index) => {
        return (
            <AttrQueryFieldRow
                key={obj.id}
                index={index}
                maxIndex={attributesCount - 1}
                entitiesTree={entitiesTree}
                value={obj}
                theme={props.theme}
                dataSourceID={dataSourceID}
                entityCollapsedDict={entityCollapsedDict}
                endlessScrolling={endlessScrolling}
                disableClickToFilter={props.disableClickToFilter}
                validEntities={attributesCount > 1 ? validEntities : null}
                tabID={props.tabID}
                glob={props.glob}
                DisplayValuesList={props.DisplayValuesList}
                hiddenFields={props.hiddenFields}
                onChange={handleChangeRow}
                onRemove={handleRemoveRow}
                onEntityCollapsedDictChange={handleEntityCollapsedDictChange}
                onSortSet={handleSortSet}
                onInitGroupingSortSet={handleInitGroupingSortSet}
            />
        );
    });

    //LL: 10.08.23  Calendar HiddenFields_Summary = ['InitGrouping','Sort', 'Format', 'More', 'Label'];
    let showInitGrouping = true;
    if (props.hiddenFields != null) {
        //showInitGrouping = (_.indexOf(props.hiddenFields, 'InitGrouping') < 0);
        showInitGrouping = props.hiddenFields.InitGrouping != true; //LL: 16.08.23
    }
    //LL: 16.08.23:
    //private static HiddenFields_Summary = {
    //        InitGrouping: true,
    //        Sort: true,
    //        Format: true,
    //        More: true,
    //        Label: true
    //    };

    //LL: 16.08.23:
    let showSort = true;
    if (props.hiddenFields != null) {
        showSort = props.hiddenFields.Sort != true;
    }
    //<th className="cell-sorting">
    //    <AttributeSortingSelectHeader />
    //</th>

    //LL: 16.08.23:
    let showFormat = true;
    if (props.hiddenFields != null) {
        showFormat = props.hiddenFields.Format != true;
    }
    //  <th className="cell-formatFront">{'Format ?'}</th>

    //LL: 16.08.23:
    let showMore = true;
    if (props.hiddenFields != null) {
        showMore = props.hiddenFields.More != true;
    }
    // <th className="cell-formatFront" title={'More Options'}>{'More...?'}</th>

    //LL: 16.08.23:
    let showLabel = true;
    if (props.hiddenFields != null) {
        showLabel = props.hiddenFields.Label != true;
    }

    //LL: 10.08.23  Calendar  hiddenFields
    //  DisplayValuesList?: any; //LL: new Calendar
    return (
        <div className={'attrquery-field-calendar'}>
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-attribute">{'Attribute'}</th>
                        <th className="cell-group-aggregate">{'Group / Aggregate'}</th>
                        {endlessScrolling !== true && showInitGrouping ? (
                            <th className="cell-init-grouping">{'Initial Grouping'}</th>
                        ) : null}
                        {showSort ? (
                            <th className="cell-sorting">
                                <AttributeSortingSelectHeader />
                            </th>
                        ) : null}
                        <th className="cell-intervals">{'Mappings'}</th>
                        {showFormat ? <th className="cell-formatFront">{'Format'}</th> : null}
                        {showMore ? (
                            <th className="cell-formatFront" title={'More Options'}>
                                {'More...'}
                            </th>
                        ) : null}
                        {showLabel ? <th className="cell-label">{'Label'}</th> : null}
                        <th className="cell-role">{'Role'}</th>
                    </tr>
                </thead>

                <tbody ref={tableRef}>
                    {rows}
                    <AttrQueryFieldRow
                        isEmpty={true}
                        entitiesTree={entitiesTree}
                        entityCollapsedDict={entityCollapsedDict}
                        dataSourceID={dataSourceID}
                        theme={props.theme}
                        endlessScrolling={endlessScrolling}
                        disableClickToFilter={props.disableClickToFilter}
                        validEntities={validEntities}
                        tabID={props.tabID}
                        glob={props.glob}
                        DisplayValuesList={props.DisplayValuesList}
                        hiddenFields={props.hiddenFields}
                        onEntityCollapsedDictChange={handleEntityCollapsedDictChange}
                        onAdd={handleAddRow}
                    />
                </tbody>
            </table>
        </div>
    );
}

